/**
 * Der Ausklang — was nach `ended` noch aus dem Lautsprecher kommt.
 * (29.09.2026, Ticket 2764)
 *
 * Martin, 28.09. 19:35: *„statt ‚fertig‘ war nur noch ‚fet‘ zu hören“*, eine
 * Minute später fehlte nur der Endlaut.
 *
 * BELEGT im Journal: Das Element hat jedes letzte Stück ganz gespielt
 * (`[tts-gap] via=ended`, echt ≥ audio). Aber mit der Stufe „nach jeder
 * Antwort“ schaltete die Sprechtaste die Tonsitzung 31–37 ms nach diesem
 * `ended` auf Aufnahme um (`[audio-diag] when=seitenaufnahme`, danach
 * getUserMedia), Ausgang `bt-a2dp`. `ended` heißt nur: das Element hat
 * seine letzten Daten abgegeben. Über Bluetooth steckt dann noch ein Stück
 * Ton in der Strecke zum Ohr — und das wirft der Wechsel weg. Seit dem
 * 25.09.: 205 Antwort-Enden mit Umschaltung nach 37 ms (Median), 93 ohne
 * Sprechtaste nach 711 ms (die Gnadenfrist in playback-hifi.ts); beide
 * Meldungen fielen auf schnelle.
 *
 * ⚠️ 600 ms: länger als eine Bluetooth-Strecke (den wirklichen Nachlauf
 *    meldet das Gerät nicht), aber KÜRZER als die Gnadenfrist (700 ms,
 *    EXIT_GRACE_MS in playback-hifi.ts). So schaltet wie bisher der Start
 *    der Sprechtaste die Sitzung selbst um und wartet darauf
 *    (warteAufAufnahmeSitzung). Liefe die Gnadenfrist zuerst ab, schaltete
 *    sie um, während getUserMedia schon anläuft — die Art Wechsel, nach der
 *    eine Aufnahme stumm blieb (Ticket 2524). Geprüft in
 *    tests/frontend/ausklang-tonsitzung-2764.test.ts.
 *
 * ⚠️ Beginnt in der Zeit ein neues Vorlesen, entfällt es: der Start der
 *    Sprechtaste bricht jedes Vorlesen ab (stopCurrentTts("ptt")) und
 *    nähme sonst genau dieses weg. Das Vorlesen beginnt mit der VERTONUNG
 *    (`tts-synthese-start`, tts-queue.ts enqueue), nicht erst mit dem Ton
 *    (`tts-audio-start`). Am Gerät dauert sie bis 4,3 s; mit dem Ton allein
 *    ging das Mikro mitten in eine laufende Vertonung auf und würgte sie ab
 *    (Nachprüfung 29.09., in Chromium mit 800 ms Vertonung nachgestellt).
 *    Der Ton bleibt als Netz, falls er ohne Vertonungs-Zeichen kommt.
 */
export const AUSKLANG_MS = 600;

/** Woran ein neues Vorlesen zu erkennen ist — und was die Diagnose dazu sagt. */
const NEUES_VORLESEN: ReadonlyArray<readonly [ereignis: string, grund: string]> = [
  ["voice-v8:tts-synthese-start", "vertonung"],
  ["voice-v8:tts-audio-start", "wiedergabe"],
];

/** `tun` erst nach dem Ausklang; `entfaellt` hört den Grund, wenn nichts geschieht. */
export function nachAusklang(
  tun: () => void,
  entfaellt?: (grund: string) => void,
  ms = AUSKLANG_MS,
): void {
  const hoerer = NEUES_VORLESEN.map(([ereignis, grund]) => {
    const h = (): void => {
      aufraeumen();
      entfaellt?.(grund);
    };
    return [ereignis, h] as const;
  });
  const aufraeumen = (): void => {
    clearTimeout(uhr);
    for (const [ereignis, h] of hoerer) window.removeEventListener(ereignis, h);
  };
  const uhr = setTimeout(() => {
    aufraeumen();
    tun();
  }, ms);
  for (const [ereignis, h] of hoerer) window.addEventListener(ereignis, h);
}
